<template>
  <div class="tm-paging">
    <tm-paging-paginator
      :entity-name="entity"
      :first-index="firstIndex"
      :last-index="lastIndex"
      :total="total"
      :total-limit="totalLimit"
      :loading="loading"
      :is-first-page="isFirstPage"
      :is-last-page="isLastPage"
      @prev="$emit('prev')"
      @next="$emit('next')"
    >
      <template v-slot:pagination-text="slotData">
        <slot
          name="pagination-text"
          v-bind="slotData"
        />
      </template>

      <template v-slot:pagination-text-append>
        <slot name="pagination-text-append" />
      </template>
    </tm-paging-paginator>

    <tm-paging-limit
      v-if="!hidePerPage"
      :value="perPage"
      :options="perPageOptions"
      @update:model-value="$emit('update:per-page', $event)"
    />
  </div>
</template>

<script setup lang="ts">
import TmPagingPaginator from '@/components/shared/paging/TmPagingPaginator.vue'
import TmPagingLimit from '@/components/shared/paging/TmPagingLimit.vue'
import type { Nullable } from '@/types'

defineProps<{
  entity: string
  firstIndex: number
  lastIndex: number
  total?: number
  totalLimit?: Nullable<number>
  isFirstPage?: boolean
  isLastPage?: boolean
  perPage?: number
  perPageOptions?: number[]
  loading?: boolean
  hidePerPage?: boolean
}>()

defineEmits<{
  prev: []
  next: []
  'update:per-page': [perPage: number]
}>()
</script>

<style lang="scss" scoped>
.tm-paging {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
